import React, { useState } from "react";

import companyServices from "../../../../services/admFin/companyServices";
import reportServices from "../../../../services/reportServices";
import compare from '../../../../functions/compare';

import ActivityIndicator from "../../../../components/ActivityIndicator";
import Card from '../../../../components/Card';
import CardItem from '../../../../components/CardItem';
import PopupReports from "../../../../components/PopupReports";
import { CompanyInfoPopUp } from "./CompanyInfoPopUp";
import CompanyPopUp from "./CompanyPopUp";
import { PopupCompanyReport } from "./PopupCompanyReport";
import { FaPen, FaPlus, FaPrint, FaTrash } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";


export default function CompaniesCard(props) {
    const [visibility, setVisibility] = useState(false);
    const [visibilityEdit, setVisibilityEdit] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);
    const [visibilityReportCompany, setVisibilityReportCompany] = useState(false);
    const [visibleInfo, setVisibleInfo] = useState(false);
    const [empresaInfo, setEmpresaInfo] = useState({});

    const [showElements, setShowElements] = useState(false);
    const companies = props.companies;

    async function createCompany(companyData) {
        console.log(companyData);
        if(companyData.nota_fiscal && (
            companyData.discriminaImpostos === null ||
            companyData.enviarEmailDestinatario === null ||
            !companyData.inscricaoEstadual ||
            /* !companyData.inscricaoMunicipal || */
            !companyData.regimeTributario ||
            companyData.habilitaNFe === null ||
            companyData.habilitaNFCe === null ||
            companyData.habilitaNFSe === null ||
            //!companyData.CSCNFCeProducao ||
            //!companyData.idTokenNFCeProducao ||
            !companyData.arquivoCertificadoBase64 ||
            !companyData.senhaCertificado

        )) {
            alert("Todos os campos obrigatórios para nota fiscal devem estar preenchidos");
            return;
        }
        if (!companyData.nome ||
            !companyData.nomeFantasia ||
            !companyData.razaoSocial ||
            !companyData.email ||
            /* !companyData.telefone ||
            !companyData.ddi ||
            !companyData.iso2 || */
            !companyData.logradouro ||
            !companyData.cidade ||
            !companyData.estado ||
            !companyData.bairro ||
            !companyData.numero ||
            !companyData.cep ||
            !companyData.cnpj ||
            companyData.moeda == null
        ) {
            alert("Os campos devem estar preenchidos");
            return;
        }
        else if (companyData.moeda === "") {
            alert("Seleciona a moeda que a empresa utiliza!");
            return;
        }
        try {
            var newCompany = null, response = await companyServices.postCompany(
                companyData.nome,
                companyData.nomeFantasia,
                companyData.razaoSocial,
                companyData.email,
                companyData.enviarEmailDestinatario,
                companyData.telefone,
                companyData.ddi,
                companyData.iso2,
                companyData.discriminaImpostos,
                companyData.logradouro,
                companyData.cidade,
                companyData.estado,
                companyData.bairro,
                companyData.numero,
                companyData.cep,
                companyData.cnpj,
                companyData.inscricaoEstadual,
                companyData.inscricaoMunicipal,
                companyData.regimeTributario,
                companyData.habilitaNFe,
                companyData.habilitaNFCe,
                companyData.habilitaNFSe,
                companyData.CSCNFCeProducao,
                companyData.idTokenNFCeProducao,
                companyData.arquivoCertificadoBase64,
                companyData.nota_fiscal,
                companyData.senhaCertificado,
                companyData.moeda
            );
            newCompany = response.data;
            try {
                let response = await companyServices.postLinkCompanyBankAccounts(newCompany.id, companyData.contasBancarias);
                newCompany = response.data;
            } catch (err) {
                alert("Não foi possível registrar as contas bancárias da nova empresa");
            }
            props.setCompanies(oldArray => {
                const temp = [...oldArray];
                temp.push(newCompany);
                temp.sort((a, b) => compare(a.nome, b.nome));
                return temp;
            })
            setVisibility(false);
        } catch (err) {
            alert("Não foi possível criar a empresa");
        }
    }

    async function editCompany(companyData) {
        console.log(companyData);
        if(companyData.nota_fiscal && (
            companyData.discriminaImpostos === null ||
            companyData.enviarEmailDestinatario === null ||
            !companyData.inscricaoEstadual ||
            /* !companyData.inscricaoMunicipal || */
            !companyData.regimeTributario ||
            companyData.habilitaNFe === null ||
            companyData.habilitaNFCe === null ||
            companyData.habilitaNFSe === null ||
            //!companyData.CSCNFCeProducao ||
            //!companyData.idTokenNFCeProducao ||
            !companyData.arquivoCertificadoBase64 ||
            !companyData.senhaCertificado

        )) {
            alert("Todos os campos obrigatórios para nota fiscal devem estar preenchidos");
            return;
        }
        if (!empresaInfo.id ||
            !companyData.nome ||
            !companyData.nomeFantasia ||
            !companyData.razaoSocial ||
            !companyData.email ||
            /* !companyData.telefone ||
            !companyData.ddi ||
            !companyData.iso2 || */
            !companyData.logradouro ||
            !companyData.cidade ||
            !companyData.estado ||
            !companyData.bairro ||
            !companyData.numero ||
            !companyData.cep ||
            !companyData.cnpj ||
            companyData.moeda == null
        ) {
            alert("Os campos devem estar preenchidos");
            return;
        }
        else if (companyData.moeda === "") {
            alert("Seleciona a moeda que a empresa utiliza!");
            return;
        }
        try {
            var newCompany = null, response = await companyServices.patchCompany(
                empresaInfo.id,
                companyData.nome,
                companyData.nomeFantasia,
                companyData.razaoSocial,
                companyData.email,
                companyData.enviarEmailDestinatario,
                companyData.telefone,
                companyData.ddi,
                companyData.iso2,
                companyData.discriminaImpostos,
                companyData.logradouro,
                companyData.cidade,
                companyData.estado,
                companyData.bairro,
                companyData.numero,
                companyData.cep,
                companyData.cnpj,
                companyData.inscricaoEstadual,
                companyData.inscricaoMunicipal,
                companyData.regimeTributario,
                companyData.habilitaNFe,
                companyData.habilitaNFCe,
                companyData.habilitaNFSe,
                companyData.CSCNFCeProducao,
                companyData.idTokenNFCeProducao,
                companyData.arquivoCertificadoBase64,
                companyData.senhaCertificado,
                companyData.nota_fiscal,
                companyData.moeda
            );
            newCompany = response.data;
            try {
                response = await companyServices.postLinkCompanyBankAccounts(newCompany.id, companyData.contasBancarias);
                newCompany = response.data;
            } catch (err) {
                alert("Não foi possível editar as contas bancárias da empresa");
            }
            props.setCompanies(oldArray => {
                return oldArray.map(obj => obj.id === empresaInfo.id ? newCompany : obj);
            })
            setVisibilityEdit(false);
        } catch (err) {
            alert("Não foi possível editar a empresa");
        }
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportRecords(companies, "RELATÓRIO DE EMPRESAS", fields, fileName);
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    return (
        <Card
            tittle={props.tittle}
            options={
                <>
                    <button onClick={() => setVisibility(!visibility)} className="records-new-item-button"><FaPlus /></button>
                    <CompanyPopUp
                        tittle="Nova Empresa"
                        buttonTittle="Criar"
                        visibility={visibility}
                        setVisibility={setVisibility}
                        onClick={createCompany}
                        bankAccounts={props.bankAccounts}
                    />
                    <button title="Relatório" onClick={() => setVisibilityReport(true)} className="records-new-item-button"><FaPrint /></button>
                    <PopupReports
                        visibility={visibilityReport}
                        setVisibility={setVisibilityReport}
                        tittle={`Relatório de Empresas`}
                        fields={reportServices.recordFields}
                        generateReport={generateReport}
                    />

                    <button
                        onClick={() => setShowElements(!showElements)}
                        className={"records-hide-elements-button" + (showElements ? " showing" : "")}
                    >
                        <IoIosArrowDown />
                    </button>
                </>
            }
        >
            {
                !showElements ?
                    null
                    :
                    <div className="records-elements">
                        {
                            companies && companies.length ?
                                <>
                                    <CompanyInfoPopUp
                                        visibility={visibleInfo}
                                        setVisibility={setVisibleInfo}
                                        empresa={empresaInfo}
                                    />
                                    <CompanyPopUp
                                        visibility={visibilityEdit}
                                        setVisibility={setVisibilityEdit}
                                        tittle="Editar Empresa"
                                        buttonTittle="Editar"
                                        empresa={empresaInfo}
                                        onClick={editCompany}
                                        bankAccounts={props.bankAccounts}
                                    />
                                    <PopupCompanyReport
                                        visibility={visibilityReportCompany}
                                        setVisibility={setVisibilityReportCompany}
                                        companyInfo={empresaInfo}
                                    />
                                    {
                                        companies.map((company) =>
                                            <div className="records-element-container" key={company.id}>
                                                <div
                                                    onClick={() => {
                                                        setEmpresaInfo(company);
                                                        setVisibleInfo(!visibleInfo);
                                                    }}
                                                >
                                                    <CardItem
                                                        removeLeftSpace
                                                        bodyOptions={<span className="tag">COD {company.id}</span>}
                                                    >
                                                        <h4>
                                                            {company.nome}
                                                        </h4>
                                                    </CardItem>
                                                </div>
                                                <button onClick={() => {
                                                    setEmpresaInfo(company);
                                                    setVisibilityEdit(true);
                                                }}>
                                                    <FaPen />
                                                </button>

                                                <button onClick={() => {
                                                    setEmpresaInfo(company);
                                                    setVisibilityReportCompany(true);
                                                }}>
                                                    <FaPrint />
                                                </button>
                                                <button className="red" onClick={() => props.deleteElement(company.id, companyServices.deleteCompany, props.setCompanies)}>
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        )
                                    }
                                </>
                                :
                                <ActivityIndicator />
                        }
                    </div>
            }
        </Card>

    )
}